import { on, each } from '../helpers/shortcuts';
import S from './shared';

export default () => {
  const accordions = document.querySelectorAll('.c-accordion');

  if (accordions.length < 1) {
    return;
  }

  each(accordions, accordionContainer => {
    let currentSlide = 0;
    const slides = accordionContainer.querySelectorAll('.c-accordion__item');
    const dots = accordionContainer.querySelectorAll('.o-dots__button');
    const title = accordionContainer.querySelector('.c-accordion__title');
    const trigger = accordionContainer.querySelector('.c-accordion__arrow');
    const next = accordionContainer.querySelector('.c-accordion__next');

    const setSlide = index => {
      slides[currentSlide].classList.remove(S.CSS.active);

      if (dots[currentSlide] !== undefined) {
        dots[currentSlide].classList.remove(S.CSS.active);
      }

      currentSlide = index;
      slides[currentSlide].classList.add(S.CSS.active);

      if (dots[currentSlide] !== undefined) {
        dots[currentSlide].classList.add(S.CSS.active);
      }
    };

    on('click', [title, trigger], event => {
      event.preventDefault();
      accordionContainer.classList.toggle(S.CSS.active);
    });

    if (next !== null) {
      on('click', next, event => {
        event.preventDefault();
        setSlide((currentSlide + 1) % slides.length);
      });
    }

    if (dots.length > 0) {
      each(dots, (dot, index) => {
        on('click', dot, event => {
          event.preventDefault();
          setSlide(index);
        });
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/accordions.js